import React from 'react';

import { languageController } from '../../../../controllers/language/languageController';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  type: string;
  name: string;
  id?: string;
  value: string;
  label?: string;
  errorMessage?: string;
  isRequired?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  showOptional?: boolean;
  extraClass?: string;
}

const Input: React.FC<InputProps> = ({
  type,
  name,
  id,
  value,
  label,
  errorMessage,
  isRequired,
  onChange,
  onBlur,
  showOptional = false,
  extraClass,
  ...otherProps
}) => {
  return (
    <div className={`mz-form-item mz-form-item--${type} ${extraClass ? extraClass : ''}`}>
      <input
        type={type}
        name={name}
        className='mz-form-item__textfield'
        id={id}
        value={value}
        required={isRequired}
        onChange={onChange}
        onBlur={onBlur}
        {...otherProps}
      />
      {label && (
        <label
          className={`mz-form-item__label ${value.length ? 'shrink' : ''}`}
          htmlFor={id}
        >
          {label}{(isRequired && label) && (<span className="mz-form-item__required-star">*</span>)}
        </label>
      )}
      {showOptional && (
        <div className="label text--grey">{languageController.getFormCopy('label', 'optional')}</div>
      )}
      {errorMessage && (
        <div className="mz-form-item__error-message">{errorMessage}</div>
      )}
    </div>
  );
};

export default Input;
